import L from "leaflet";
import iconRetinaUrl from "@/assets/img/icons/map-pointer2х.png";
import markedIconRetinaUrl from "@/assets/img/icons/map-pointer2х_marked.png";
import iconUrl from "@/assets/img/icons/map-pointer1х.png";
import markedIconUrl from "@/assets/img/icons/map-pointer1х_marked.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

const MARKER_COLORS = {
  default: "#8b95a5",
  selected: "#2f84f8",
  audio: "#eb3b3b",
  video: "#f5c518",
};

function cameraIcon(state) {
  const isEvent = state === "audio" || state === "video";
  return L.icon({
    className: `aircraft-events-map__camera-marker aircraft-events-map__camera-marker_${state}${isEvent ? " aircraft-events-map__event-marker" : ""}`,
    iconRetinaUrl: isEvent ? markedIconRetinaUrl : iconRetinaUrl,
    iconUrl: isEvent ? markedIconUrl : iconUrl,
    iconSize: [37, 52],
    iconAnchor: [18, 51],
    popupAnchor: [0, -47],
    shadowAnchor: [12, 39],
    shadowUrl,
  });
}

export const cameraMarkerIcons = {
  default: cameraIcon("default"),
  selected: cameraIcon("selected"),
  audio: cameraIcon("audio"),
  video: cameraIcon("video"),
};

export function aircraftEventColor(message) {
  return MARKER_COLORS[message && message.source_type] || MARKER_COLORS.selected;
}

export const selectionPointIcon = L.divIcon({
  className: "aircraft-events-map__selection-point",
  html: "<span></span>",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
